// extracted by mini-css-extract-plugin
export default {"wrapper":"DirectoryBadge_wrapper__07xHc","img":"DirectoryBadge_img__dQTpI","badgeCount":"DirectoryBadge_badgeCount__YT1RX"};